var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "22", viewBox: "0 0 24 22", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { id: "Read-Receipts-Web/Mweb", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { id: "Hover-state", transform: "translate(-945 -991)", fill: "#0000BF", fillRule: "nonzero" },
        React.createElement(
          "g",
          { id: "Group-3", transform: "translate(932 976)" },
          React.createElement(
            "g",
            { id: "NewBrand-Icons-Nav-Messages-(1)", transform: "translate(13 15)" },
            React.createElement("path", { d: "M23.25.071a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75H6.418L1.28 21.71a.75.75 0 0 1-1.28-.53V.82a.75.75 0 0 1 .75-.75h22.5zm-.75 1.5h-21v17.797l4.077-4.077a.75.75 0 0 1 .53-.22H22.5v-13.5zM15 9.714a.75.75 0 1 1 0 1.5H6a.75.75 0 1 1 0-1.5h9zm3-4.286a.75.75 0 1 1 0 1.5H6a.75.75 0 1 1 0-1.5h12z", id: "Combined-Shape" })
          )
        )
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/shared/components/svgs/conversation.svg